// Generated from public/images/bestiary/starfinder: each Starfinder creature name (both editions,
// lowercased, letters and digits only) to the file stem of its picture. File names describe the
// picture rather than naming the creature, so the pairs were matched by name and checked by hand
// against the stat blocks (weapons, homeworld, size); a creature with no confident match has no
// entry and keeps the lettered token. Looked up by creatureFallbackArt in utilities/tokenArt.js.

const STARFINDER_CREATURE_ART = {
    adultabysiumdragon: 'radioactive_crystal_dragon',
    adultcosmicdragon: 'cosmic_winged_alien_dragon',
    aeonguard: 'moss_green_aeon_guard_rifleman',
    aeonguardspecialist: 'elite_aeon_guard_infiltrator',
    aeonguardtrooper: 'moss_green_aeon_guard_rifleman',
    agathionclaustral: 'claustral_agathion_celestial_lion_guardian',
    agathionvicunal: 'four_armed_celestial_herbivore_healer',
    ahav: 'ahav_heavy_hover_assault_machine',
    akata: 'cobalt_tentacle_mane_akata_predator',
    anaciteambassador: 'anacite_ambassador_of_aballon',
    anacitelaborer: 'six_legged_aballon_construction_automaton',
    anacitewingbot: 'anacite_solar_wingbot',
    ancientabysiumdragon: 'radioactive_crystal_dragon',
    ancientcosmicdragon: 'cosmic_winged_alien_dragon',
    animatedlashuntamindmailiii: 'animated_mind_mail_with_sonic_disks',
    animatedlictorhellknightplate: 'ember_visor_hellknight_plate',
    animatedquartzswarm: 'runed_quartz_swarm',
    apari: 'apari_the_swarming_hive_beetle',
    apariconstituent: 'apari_constituent_four_winged_hive_soldier',
    arabuk: 'four_eyed_arctic_antlered_arabuk',
    arabukyearling: 'stalking_arabuk_yearling',
    arquandgazelle: 'tranquil_six_legged_lyre_horned_gazelle',
    assemblyooze: 'the_circuit_assembly_ooze',
    asteray: 'asteray_ribbon_tailed_deep_angel',
    astriapidefender: 'astrapi_defender_wasp_borne_arc_sentinel',
    astriapiwarden: 'astriapi_warden_of_emerald_vines',
    atlapak: 'juvenile_atlapak_mantis_shrimp',
    atlapakjuvenile: 'juvenile_atlapak_mantis_shrimp',
    azatatritidair: 'starwinged_azata_with_a_starknife',
    barachius: 'circuit_winged_barachius_angel',
    barachiusangel: 'circuit_winged_barachius_angel',
    barathu: 'crimson_barathu_sky_drifter',
    barathuearlystage: 'juvenile_barathu_blimp_jellyfish',
    bearavengeruplifted: 'armored_uplifted_bear_avenger',
    bearconstellateuplifted: 'uplifted_bear_in_stellar_armor',
    bloodbrother: 'bloodbrother_frost_rib_centipede',
    bodysnatcherautocrat: 'neural_bodysnatcher_ooze',
    bodysnatcherslime: 'glow_threaded_emerald_bodysnatcher_slime',
    bolidaminer: 'bronze_bolida_miner_with_pike',
    bolidaoverseer: 'bolida_overseer_engineer_of_the_deep',
    bonetroopercaptain: 'eoxian_bone_trooper_captain',
    bonetroopertechnomancer: 'elebrian_bone_trooper_technomancer',
    braincollector: 'seven_sac_alien_brain_collector',
    brenneriambassador: 'breneri_ambassador_in_diplomatic_stationwear',
    brennerisage: 'varturan_otter_mystic_with_mindlinks',
    carrionwheel: 'aucturn_s_writhing_carrion_wheel',
    carrionwheelichor: 'the_black_ichor_wheel',
    caypin: 'starfinder_caypin_the_eyestalk_predator',
    cephalume: 'bioluminescent_cephalume_duelist',
    cerebricfungus: 'cerebric_fungus_star_voyager',
    cerebricfungusvoyager: 'cerebric_fungus_star_voyager',
    cloudray: 'gargantuan_three_tailed_cloud_ray',
    cloudskate: 'cloud_skate_agile_sky_ray',
    colouroutofspace: 'spectral_chromatic_ooze',
    contemplative: 'ashok_s_levitating_brainbound_alien',
    contemplativementor: 'akiton_s_exalted_brain_mystic',
    copaxisocialite: 'coral_envoy_of_tabrid_minor',
    copaxispecialops: 'coral_horned_solarian_with_plasma_blade',
    corpsefleetinfantry: 'corpse_fleet_elite_acid_rifleman',
    corpsefolkmarine: 'corpse_fleet_elite_acid_rifleman',
    corpsefolkoperative: 'corpsefolk_stealth_agent_with_arc_pistol',
    cresteater: 'crest_eater_six_limbed_antler_shell_predator',
    cyberneticzombie: 'cybernetic-zombie',
    daemonalorbidaemon: 'fused_alorbidaemon_hover_pod_abomination',
    daemonalucidaemon: 'gaunt_alucidaemon_in_hovering_life_pod',
    damai: 'damai_survivalist_of_daimalko',
    damaiguardian: 'damai_guardian_and_rune_orb',
    dawnbeetlecorediver: 'molten_core_diver_dawn_beetle',
    dawnbeetlesunscrapper: 'iridescent_dawn_beetle_with_scrap_ball',
    defrex: 'armored_defrex_predator_from_vesk_2',
    defrexjuvenile: 'juvenile_defrex_with_defensive_back_spines',
    dehnolo: 'deh_nolo_the_four_pod_biowarden',
    demonpluprex: 'irradiated_abyssal_pluprex',
    demonprexianmutantspawn: 'floating_radiant_prexian_mutantspawn',
    dessamarimago: 'dessamar_imago_violet_winged_spear_explorer',
    dessamartheurgist: 'dessamar_starbound_butterfly_theurgist',
    devilendbringerdevildhalochar: 'endbringer_devil_infernal_starship_titan',
    devilwarmongerdevillevaloch: 'levaloch_the_six_legged_war_knight',
    diasporaworm: 'blind_fanged_diaspora_wyrm',
    diasporawormsage: 'ancient_frill_crowned_diaspora_wyrm',
    diasporawyrm: 'blind_fanged_diaspora_wyrm',
    diasporawyrmsaga: 'ancient_frill_crowned_diaspora_wyrm',
    diatha: 'diatha_the_bioluminescent_explosive_slug',
    diathaelder: 'amber_finned_diatha_elder',
    dinosaurceratopsid: 'charging_triceratops_three_horned_giant',
    dinosaurdromaeosaurid: 'feathered_deinonychus_in_mid_pounce',
    dinosaurplesiosaur: 'majestic_blue_green_plesiosaur',
    dinosaurpterosaur: 'majestic_pteranodon_with_translucent_wings',
    dinosaursauropod: 'towering_sauropod_bestiary_illustration',
    dinosaurtheropod: 'roaring_tyrannosaur_in_mid_charge',
    dinosaurthyreophoran: 'armored_clubtail_dinosaur',
    dirindifabulist: 'three_eyed_dirindi_fabulist_with_arc_pistol',
    dirindimonsterhunter: 'three_eyed_dirindi_monster_hunter',
    draelik: 'draelik_mystic_with_shadowstaff',
    dragonchromaticyoungadultbluedragon: 'lightning_horned_starfinder_blue_dragon',
    dragonkin: 'armored_dragonkin_warrior_with_thunder_glaive',
    dragonmetallicadultsilverdragon: 'silver_dragon_sovereign',
    dragonouteroldvoiddragon: 'ancient_starfinder_void_dragon',
    dragonstarmetalmatureadulthoracalcumdragon: 'horacalcum_starfinder_time_dragon',
    dreamer: 'prismatic_dreamer_oracle',
    driftdeadamalgam: 'driftdead_amalgam_conjoined_void_horror',
    driftnativedriftarchitech: 'violet_three_ring_drift_architect',
    driftnativetimeeater: 'opaline_crystal_time_eater',
    dromada: 'eyestalk_dromada_field_scout',
    dromadavigilant: 'vigilant_dromada_security_sentinel',
    drowdrowenforcer: 'apostae_drow_laser_enforcer',
    drowdrownoblearmsdealer: 'apostae_drow_arms_dealer',
    dustmanta: 'starfinder_dust_manta_sand_burrowing_beast',
    dustmantamonarch: 'three_tailed_dust_manta_monarch',
    electrovore: 'bioelectric_winged_eel_beast',
    elementalelderearthelemental: 'elder_granite_earth_colossus',
    elementalelderelemental: 'elder_tempest_elemental',
    elementalgreaterelemental: 'greater_fire_elemental',
    elementalhugeearthelemental: 'huge_granite_earth_elemental',
    elementalhugeelemental: 'colossal_tidal_water_elemental',
    elementallargeearthelemental: 'large_ocher_stone_earth_elemental',
    elementallargeelemental: 'cresting_teal_water_elemental',
    elementalmediumearthelemental: 'stubborn_little_earth_elemental',
    elementalmediumelemental: 'dancing_medium_fire_elemental',
    elementalsmallearthelemental: 'stubborn_pebble_earth_elemental',
    elementalsmallelemental: 'graceful_sea_glass_air_elemental',
    elementaltinyearthelemental: 'tiny_amber_eyed_pebble_elemental',
    elementaltinyelemental: 'tiny_air_elemental_sprite',
    ellicoth: 'ellicoth_twin_trunk_radiation_behemoth',
    embri: 'embrí_the_masked_mollusk_official',
    emotivore: 'ash_blue_emotivore_hailstorm_pistol_ready',
    emotivoremastermind: 'elegant_emotivore_mastermind_with_sonic_pistol',
    endlingkorvui: 'spectral_korvui_endling',
    entucolony: 'opalescent_entu_colony_with_tactical_baton',
    entucolonynelentu: 'nelentu_the_symbiotic_winged_scout',
    epokasitefixer: 'floating_copper_fey_tinker',
    epokasiterunner: 'epokasite_runner_clockwork_flame_saboteur',
    equinoxianapastra: 'equinoxian_apastra_sunfire_and_void',
    equinoxianperiastra: 'equinoxian_periastra_guardian_of_cosmic_balance',
    espraksa: 'espraksa_icy_winged_explorer',
    espraksaperformer: 'emerald_eyed_espraksa_ribbon_performer',
    ferrofluidmagnetocluster: 'ferrofluid_magneto_cluster_colossus',
    ferrofluidooze: 'ferrofluid_ooze_with_magnetized_spines',
    ferrofluidoozeferrofluidmagnetocluster: 'ferrofluid_magneto_cluster_colossus',
    flayerleech: 'five_petaled_flayer_leech',
    flayerleecheffigy: 'stitched_leech_effigy_with_plasma_pistol',
    formianmyrmarch: 'formian_myrmarch_chitinous_sonic_general',
    formianqueen: 'majestic_formian_queen_with_sonic_pistol',
    formiantaskmaster: 'formian_taskmaster_with_sonic_blaster',
    formianwarrior: 'armored_formian_warrior_with_rifle_and_stinger',
    formianworker: 'formian_worker_with_mining_gear',
    frujaicolony: 'three_legged_frujai_fungal_hive',
    frujaisoldier: 'frujai_soldier_mycelial_gravity_guardian',
    garaggakal: 'garaggakal_the_lamprey_mouthed_drift_wraith',
    garaggakalpolymath: 'ancient_lamprey_mouthed_drift_wraith',
    ghoranflorashaper: 'flower_faced_ghoran_flora_shaper',
    ghoranworldtamer: 'ghoran_world_tamer_scout',
    ghost: 'starborne_ghost_mystic_with_violet_mindfire',
    ghoul: 'eox_urban_ghoul_with_laser_pistol',
    ghoulshocktrooper: 'armored_ghoul_with_perihelion_cannon',
    giantmoon: 'regal_moon_giant_with_crescent_diadem',
    glassserpent: 'iridescent_glass_serpent_with_crystalline_tentacle',
    goblinhonchoheadspace: 'space_goblin_junklaser_honchohead',
    goblinzaperatorspace: 'space_goblin_with_a_junklaser',
    golemcybernetic: 'corona_cannon_cybernetic_golem',
    golemnanotech: 'roiling_chrome_nanotech_golem',
    golemneutronium: 'neutronium_golem_gravity_bound_guardian',
    gray: 'telepathic_gray_with_needler_pistol',
    graygoo: 'silver_nanite_maelstrom',
    gremlincomputerglitch: 'circuit_hacking_glitch_gremlin',
    gremlinhobkins: 'hobkins_gremlin_s_holographic_trick',
    gremlinhobkinsmalefactor: 'nebula_skinned_psychic_gremlin',
    gremlinshipglitch: 'lamprey_mouthed_ship_glitch_gremlin',
    grioth: 'voidglass_grioth_eclipse_seer',
    griotheclipseseer: 'voidglass_grioth_eclipse_seer',
    haan: 'haan_sky_hunter_with_silk_balloon',
    haancombatpilot: 'silkborne_haan_combat_pilot',
    hadrogaanhyperanalyst: 'hadrogaan_crystal_hyper_analyst',
    hadrogaansmartmerc: 'hadrogaan_smart_merc_with_violet_crystal_armor',
    haeshishaahaeshiform: 'haeshi_shaa_s_churning_tar_form',
    haeshishaashaaform: 'haeshi_shaa_s_churning_tar_form',
    hallajin: 'hallajin_the_living_aurora',
    hanakanattendant: 'mystical_hanakan_attendant_with_blue_wisp',
    hanakansoulstonehunter: 'hanakan_soulstone_hunter',
    harpyjasmine: 'harpy_jasmine_carnivorous_starflower_vine',
    hashukayak: 'corrected_eight_legged_hashukayak',
    herdanimalcolossal: 'colossal_crescent_horned_herd_matriarch',
    herdanimalgargantuan: 'gargantuan_crescent_horned_alien_grazer',
    herdanimalhuge: 'crescent_horned_titan_grazer',
    herdanimallarge: 'crescent_horned_slate_gray_alien_grazer',
    herdanimalsmall: 'small_horned_alien_herd_grazer',
    hesper: 'hesper_the_nuclear_reactor_fey',
    hobgoblinlieutenant: 'hobgoblin_lieutenant_in_golemforged_armor',
    hobgoblintrooper: 'starfinder_hobgoblin_trooper_with_laser_rifle',
    hortus: 'hortus_mushroom_scout_with_tactical_pike',
    hortushortinarch: 'hortus_hortinarch_fungal_technomancer',
    houndoftindalos: 'violet_hound_of_tindalos',
    houndoftindalosthingfrombeyondtime: 'colossal_hound_beyond_time',
    hulsa: 'hulsa_the_radiant_brass_fey_golem',
    ichorlord: 'starfinder-orocoran-ichor-lord',
    ignursoburrower: 'ember_eyed_volcanic_burrower',
    ignursomason: 'basalt_behemoth_with_magma_veins',
    ijtikri: 'armored_ijtikri_pathfinder_of_vesk_2',
    ijtikricommando: 'crimson_ijtikri_commando_with_thunderstrike_rifle',
    ikeshtibroodminder: 'akiton_lizardfolk_technomancer',
    ikeshtirivener: 'mutated_desert_lizardfolk_berserker',
    inevitableanhamut: 'anhamut_the_nanite_blade_guardian',
    irokiroi: 'sightless_helical_sky_serpent',
    irokiroioshirokiroi: 'oshirokiroi_cr12_helical_fin_serpent',
    itmivruh: 'ancient_itmi_vruh_memory_bound_specter',
    itmivruhreminiscent: 'ancient_itmi_vruh_memory_bound_specter',
    ixtangi: 'ixtangi_disruptor_cr7',
    ixtangidisruptor: 'ixtangi_disruptor_cr7',
    izalguunhealer: 'six_limbed_izalguun_healer',
    izalguunhunter: 'six_limbed_izalraan_hunter',
    jinsulbasecommander: 'six_legged_obsidian_alien_commander',
    jinsulwarrior: 'rust_armored_six_legged_arcblade_warrior',
    jububnanraconteur: 'one_legged_neon_toad_raconteur',
    jububnantraveler: 'jububnan_one_legged_starfarer',
    juvenilesolarwisp: 'juvenile_solar_plasma_wisp',
    kaionmultipole: 'magnetic_chimeric_kaion_colony',
    kalodeepspeaker: 'kalo_deepspeaker_mystic_scholar',
    kalosharkhunter: 'kalo_sharkhunter_tactical_dive_marksman',
    kamitsukumogami: 'tiny_antique_communicator_spirit',
    khefak: 'akitonian_khefak_rustbound_centipede_crab',
    khefakthasteron: 'thasteron_khefak_radiant_crystal_menace',
    khulan: 'khulan_spirit_of_the_cooling_core',
    khulanascendant: 'molten_core_khulan_ascendant',
    kiirintaguard: 'sapphire_winged_kiirinta_guard',
    kiirintashaman: 'mothwing_kiirinta_shaman_casting_vines',
    klikharphatchling: 'prismatic_hopping_cricket_companion',
    klikharpmount: 'iridescent_alien_cricket_mount_with_saddle',
    koruviendling: 'spectral_korvui_endling',
    kothama: 'star_gazing_kothama_of_vesk_8',
    kothamaascendant: 'ascendant_kothama_star_shaman',
    ksarik: 'ksarik_the_verdant_stalker',
    kyokor: 'kyokor_the_crimson_cracked_colossus',
    lacunalcollector: 'alabaster_relic_archivist_with_energy_spear',
    lacunalcollectorinitiate: 'lacunal_initiate_with_relic_head',
    livinghologram: 'prismatic_hardlight_tech_ghost',
    lumocantha: 'lumocantha_the_ruby_spined_laser_flower',
    lumocanthaancient: 'ancient_ruby_spined_laser_flower',
    lurkerinlight: 'luminous_four_winged_fey_scout',
    lurkerinlightlightweaver: 'irradiated_lightweaver_with_neutron_pistol',
    manymienedone: 'many_miened_lunar_crystal_golem',
    maraquoihunter: 'marata_hunter_with_spear_and_pulsecaster',
    maraquoishaman: 'maraquoi_shaman_with_healing_sigil',
    maroonedone: 'marooned_void_revenant',
    maturesolarwisp: 'mature_solar_wisp_orb',
    migo: 'mi_go_high_priest_with_occult_pistol',
    migohighpriest: 'mi_go_high_priest_with_occult_pistol',
    moonflower: 'moonflower_the_rooted_carnivorous_blossom',
    moonflowertitan: 'moonflower_titan_colossal_root_maw',
    moongiant: 'regal_moon_giant_with_crescent_diadem',
    mordagast: 'spectral_mordagast_the_ambush_hunter',
    mordagastbutcher: 'gargantuan_phase_shifted_mordagast_butcher',
    morlamaw: 'vibrant_morlamaw_four_tusked_aquatic_alien',
    morlamawmayor: 'morlomaw_mayor_in_a_golden_suit',
    mountaineel: 'castrovel_s_winged_mountain_eel',
    mummifiedprophet: 'silicon_mummy_mummified_prophet',
    murzzilat: 'murzzilat_with_six_hooked_limbs',
    murzzilatbantling: 'teal_eyed_murzzilat_bantling',
    necrovite: 'eoxian_bone_sage_with_wrackstaff',
    nihili: 'creeping_voidspace_revenant',
    nuarenforcer: 'armored_minotaur_enforcer_with_techno_hammer',
    nuarspecialist: 'minotaur_tech_warrior_operative',
    observerclasssecurityrobot: 'hovering_orbital_surveillance_drone',
    oma: 'celestial_leviathan_whale',
    onijanoi: 'cyber_oni_warlord_with_purple_magic',
    onikanabocommando: 'cyber_oni_warlord_with_spiked_kanabo',
    orctechnician: 'starfinder-orc-technician',
    orctrooper: 'starfinder-orc-trooper',
    orocoran: 'starfinder-orocoran',
    orocoranichorlord: 'starfinder-orocoran-ichor-lord',
    osharu: 'starfinder-osharu',
    osharuheadteacher: 'axolotl_astronomer_academy_headmaster',
    pahtrainquisitive: 'tactical_feline_explorer_with_holographic_map',
    pahtrastalker: 'stealth_feline_rogue_in_ambush_pose',
    phentomite: 'phentomite_grappling_specialist',
    phentomitebridger: 'alien_climber_with_grappling_gear',
    philosopherworm: 'arcane_worm_philosopher_with_celestial_orbs',
    philosopherwormteleologarch: 'arcane_worm_philosopher_with_celestial_orbs',
    planarscionganzi: 'planar_scion_with_chaotic_energy',
    planarsciontiefling: 'crimson_tiefling_space_rogue',
    plasmalisk: 'neon_plasma_dragon_reptile',
    plasmaooze: 'electric_plasma_ooze_monster',
    polyphonicgel: 'polyphonic_neon_ooze_aberration',
    polyphonicplasm: 'polyphonic_neon_ooze_aberration',
    predatorcolossal: 'armored_cyan_leviathan_predator',
    predatorgargantuan: 'gargantuan_cyan_glow_alien_predator',
    predatorhuge: 'cyan_glow_armored_alien_predator',
    predatorlarge: 'armored_cyan_spined_alien_predator',
    predatormedium: 'cyan_spined_alien_predator',
    predatorsmall: 'bioluminescent_alien_predator',
    predatorswarm: 'alien_predator_swarm_assault',
    proteandurgastr: 'durgastr_chaos_serpent_in_prismatic_spiral',
    psacynoidcustodian: 'psacynoid_crystal_custodian',
    psacynoidgallant: 'solar_shield_psacynoid_gallant',
    psychopompmorrigna: 'veiled_spider_queen_of_the_web',
    quantumslime: 'quantum_cosmic_slime_entity',
    quorlu: 'volcanic_crystal_eyed_alien_construct',
    quorlusapper: 'volcanic_crystal_demolition_engineer',
    radiationdrakeadult: 'radioactive_neon_drake_in_midair',
    rageshkorrock: 'roaring_crystal_armored_rock_dragon',
    ravenousdrake: 'domesticated_ravenous_drake_mount',
    ravenousdrakedomesticated: 'domesticated_ravenous_drake_mount',
    ravenousdrakeferal: 'ravenous_void_drake_lunge',
    raxilitebioengineer: 'whimsical_plant_alien_bioengineer',
    raxiliteresearcher: 'botanical_alien_xenobiologist_researcher',
    reptoid: 'reptilian_stealth_operative_with_blaster_and_blade',
    reptoidmaster: 'reptilian_psionic_lord_with_arcane_staff',
    robotassassin: 'stealth_assassin_android_with_red_accents',
    robotdragonassaultlaser: 'cybernetic_dragon_unleashing_plasma',
    robotexterminatorclassinfiltration: 'crimson_infiltrator_mech_assassin',
    robotguardian: 'armored_blue_energy_guardian_mech',
    robotroguecombatdrone: 'menacing_red_eyed_combat_drone',
    robotsecurityobserverclass: 'hovering_orbital_surveillance_drone',
    robotsecuritypatrolclass: 'futuristic_security_robot_with_rifle',
    robotsiegerobot: 'gothic_siege_mech_behemoth',
    ryphoriantechnician: 'winter_ryphorian_tech_operative',
    sapientpurpleorb: 'levitating_cosmic_orb_entity',
    sapientpurpleorbluminant: 'mystical_cosmic_orb_entity',
    sarcesiansniper: 'alien_sniper_with_glowing_plasma_rifle',
    sazaronsage: 'sazaron_sage_cosmic_centaur_scholar',
    sazaronscholar: 'Starfinder_Sazaron_Scholar_Corrected_4_Legs',
    scavengerslime: 'iridescent_scrapship_slime_construct',
    seenthe: 'many_eyed_violet_winged_beast',
    shakaltastarguardian: 'celestial_star_guardian_in_flight',
    shimreenwarrior: 'crystalline_ember_warrior_with_spear',
    shimreenworker: 'crystal_miner_engineer_with_ember_lance',
    shipmind: 'nebula_shipmind_ai_core',
    shobhad: 'four_armed_desert_warrior',
    shobhadwarleader: 'four_armed_tusked_alien_warlord',
    shotalashu: 'savage_shotalashu_predator',
    shotalashuferalshotalashu: 'savage_shotalashu_predator',
    skittermander: 'six_armed_alien_adventurer',
    skittermanderwhelp: 'cheerful_six_armed_alien_adventurer',
    skreeling: 'starfinder-skreeling',
    skreesire: 'starfinder-skreesire',
    sombrianlumyr: 'starfinder-sombrian-lumyr',
    sombriansolmyr: 'starfinder-sombrian-solmyr',
    spathinaeexplorer: 'starfinder-spathinae-explorer',
    spectrasondria: 'sondria_celestial_resonance_entity',
    squox: 'trained-squox',
    stormghost: 'storm_wraith_with_electric_eyes',
    stridermander: 'six_armed_teal_alien_predator',
    stridermandertyrant: 'six_armed_iridescent_alpha_beast',
    supengapup: 'Starfinder_Supenga_Pup',
    supengatitan: 'supenga-titan',
    surnoch: 'surnoch',
    swampstridercommon: 'swamp-strider-common',
    swampstridercrested: 'swamp-strider-crested',
    symbiend: 'symbiend',
    tashtari: 'tashtari',
    tashtarialpha: 'tashtari-alpha',
    tekenki: 'tekenki',
    tekhoinos: 'tekhoinos',
    telia: 'telia',
    teliaraconteur: 'telia-raconteur',
    thasteronkhefak: 'thasteron_khefak_radiant_crystal_menace',
    thermatrod: 'thermatrod-caldera',
    thermatrodcaldera: 'thermatrod-caldera',
    theswarmcorrovox: 'swarm-corrovox',
    theswarmdissolver: 'swarm-dissolver',
    theswarmmindreaper: 'swarm-mindreaper',
    theswarmthresherlord: 'swarm-thresher-lord',
    theswarmxersk: 'swarm-xersk',
    thorgothrel: 'thorgothrel',
    thresherlord: 'swarm-thresher-lord',
    timedimensional: 'time-dimensional',
    trainedsquox: 'trained-squox',
    tripod: 'tripod',
    troll: 'troll',
    trollvoidtroll: 'void-troll',
    trox: 'trox',
    troxdefensor: 'trox-defensor',
    tryziarkaexplorer: 'tryziarka-explorer',
    tryziarkalegacycaptain: 'tryziarka-legacy-captain',
    tzitzimitl: 'tzitzimitl',
    undeadminioncyberneticzombie: 'cybernetic-zombie',
    undeadminionoccultzombie: 'occult-zombie',
    undeadminionskeletalundead: 'skeletal-undead-anatomy-v2',
    urog: 'urog',
    ursikka: 'ursikka',
    utesra: 'utesra',
    utesraphylarch: 'utesra-phylarch-v2',
    valkyrie: 'valkyrie-v2',
    varculakmarauder: 'varculak-marauder',
    varculaknoble: 'varculak-noble',
    vasporan: 'vasporan',
    vasporanbroodling: 'vasporan-broodling',
    velstracanchorite: 'velstrac-anchorite',
    verminasteroidlouse: 'asteroid-louse',
    vermincometwaspswarm: 'comet-wasp-swarm',
    verminnecropede: 'necropede',
    verminplanetoidbeetle: 'planetoid-beetle',
    verminwarpmothswarm: 'warpmoth-swarm',
    verthaniaetherpilot: 'verthani-aether-pilot',
    verthanipureone: 'verthani-pure-one',
    vlakahandler: 'vlaka-handler',
    vlakatracker: 'vlaka-tracker',
    voidhag: 'void-hag',
    voidzombie: 'void-zombie',
    vorthuul: 'vorthuul',
    vracinea: 'vracinea',
    warpstitcher: 'warpstitcher',
    weaponizeddevilinabox: 'weaponized-devil-in-a-box',
    weaponizedgamedroid: 'weaponized-gamedroid',
    witchwyrd: 'witchwyrd',
    wolliped: 'wolliped',
    wollipedaluralwarwolliped: 'alural-war-wolliped',
    worlanisi: 'worlanisi',
    worlanisifortunaut: 'worlanisi-fortunaut',
    wrikreechee: 'wrikreechee',
    yearlingarabuk: 'stalking_arabuk_yearling',
    yithian: 'yithian',
    yithianelder: 'yithian-elder',
    youngabysiumdragon: 'radioactive_crystal_dragon',
    youngcosmicdragon: 'cosmic_winged_alien_dragon',
};

export default STARFINDER_CREATURE_ART;
